import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import Datetime from 'react-datetime'
import 'react-datetime/css/react-datetime.css'
import Select from 'react-select'
import { SPORTS, getDisplayCurrency, getStatus } from 'utils/converters'
import { bookmakers, firebaseRef } from 'config'
import Firebase from 'firebase'

const sportOptions = Object.keys(SPORTS).map(k => {
  return {
    value: +k,
    label: SPORTS[k].name
  }
})

const bookmakerOptions = Object.keys(bookmakers).map(k => {
  return {
    value: +k,
    label: bookmakers[k]
  }
})

// const oddsTypeOptions = [
//   {
//     value: ODDSTYPES.threeway,
//     label: '1x2'
//   },
//   {
//     value: ODDSTYPES.moneyline,
//     label: 'Moneyline'
//   },
//   {
//     value: ODDSTYPES.points,
//     label: 'Points spread'
//   },
//   {
//     value: ODDSTYPES.totals,
//     label: 'Over/Under'
//   },
//   {
//     value: ODDSTYPES.ahc,
//     label: 'Asian Handicap'
//   },
//   {
//     value: ODDSTYPES.dnb,
//     label: 'Draw no bet'
//   }
// ]

const statusOptions = Object.keys(getStatus).map(status => {
  return {
    value: +status,
    label: getStatus[status].text
  }
})

export default class AddCustomBetModal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      sport: {
        value: 1,
        name: 'Soccer'
      },
      date: new Date(),
      bookmaker: {
        value: 126
      },
      currency: {
        value: this.props.user.currency
      },
      status: {
        value: 1
      }
    }
  }

  onChangeBookmaker(bookmaker) {
    this.setState({
      bookmaker
    })
  }

  onChangeDate(date) {
    this.setState({
      date
    })
  }

  onChangeSport(sport) {
    this.setState({
      sport
    })
  }

  onChangeCurrency(currency) {
    this.setState({
      currency
    })
  }

  onChangeStatus(status) {
    this.setState({
      status
    })
  }

  onSubmit(e) {
    e.preventDefault()
    const { status, bookmaker, currency, sport, date } = this.state
    let userbet = {
      match: {
        homeTeam: this.refs.homeTeam.value,
        awayTeam: this.refs.awayTeam.value,
        startTime: +date || Date.now()
      },
      createdAt: Firebase.ServerValue.TIMESTAMP,
      updatedAt: Firebase.ServerValue.TIMESTAMP,
      user: this.props.user.id,
      bookmaker: {
        _id: bookmaker.value,
        name: bookmakers[bookmaker.value]
      },
      sportId: sport.value,
      currency: currency.value,
      wager: +this.refs.wager.value,
      odds: +this.refs.odds.value || 2,
      status: status.value
    }
    let ref = firebaseRef.child('userbets').push()
    ref.set(userbet)
    window.analytics.track('Saved custom bet')
    this.props.onCloseCustomBetModal()
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.show !== nextProps.show) {
      return true
    }
    if (Object.keys(this.props.currencies).length !== Object.keys(nextProps.currencies).length)
      return true
    for (let key in this.state) {
      if (this.state[key] !== nextState[key])
        return true
    }
    return false
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onCloseCustomBetModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add custom bet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className='form clearfix'>
            <div className='row'>
              <div className='form-group col-xs-5'>
                <input type='text' ref='homeTeam' className='form-control' placeholder='Home team' required/>
              </div>
              <div className='form-group col-xs-2 text-center'>
                vs
              </div>
              <div className='form-group col-xs-5 pull-right'>
                <input type='text' ref='awayTeam' className='form-control' placeholder='Away team' required/>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-xs-6'>
                <Datetime value={this.state.date} onChange={this.onChangeDate.bind(this)}/>
              </div>
              <div className='form-group col-xs-6'>
                <Select name='sport'
                  options={sportOptions}
                  onChange={this.onChangeSport.bind(this)}
                  placeholder='Sport'
                  value={this.state.sport.value}
                  clearable={false}
                />
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-xs-6'>
                <Select name='bookmaker'
                  options={bookmakerOptions}
                  onChange={this.onChangeBookmaker.bind(this)}
                  placeholder='Bookmaker'
                  value={this.state.bookmaker.value}
                  clearable={false}
                />
              </div>
              <div className='form-group col-xs-6'>
                <input type='number' step={0.001} className='form-control' ref='odds' placeholder='Odds' required/>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-xs-3'>
                <Select
                  name='currency'
                  options={Object.keys(this.props.currencies).map(curr => ({value: curr, label: getDisplayCurrency[curr]}))}
                  value={this.state.currency.value}
                  onChange={this.onChangeCurrency.bind(this)}
                  clearable={false}
                />
              </div>
              <div className='form-group col-xs-3'>
                <input type='number' className='form-control' placeholder='Stake' ref='wager' required/>
              </div>
              <div className='form-group col-xs-4'>
                <Select
                  options={statusOptions}
                  value={this.state.status.value}
                  onChange={this.onChangeStatus.bind(this)}
                  clearable={false}
                />
              </div>
              <div className='form-group col-xs-12'>
                <button type='submit' onClick={this.onSubmit.bind(this)} className='btn btn-success'>Add bet</button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/mybets/AddCustomBetModal.js
 **/